import React, { memo, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
//
import { StyledBox } from "./style";
import Message from "../Message";

const Messages = memo(function Messages(props) {
  const { data, component: Component, onIntent, ...otherProps } = props;

  useEffect(() => {
    const { action = null } = data.at(-1) || {};

    if (action !== null && onIntent) {
      const id = setTimeout(() => {
        onIntent({ parameters: action });
      }, 3000);

      return () => {
        clearTimeout(id);
      };
    }
  }, [data, onIntent]);

  return data.map((value, index) => {
      const { id, content, action = null, asking, ..._otherProps } = value;
      
      // Encontrar a primeira mensagem do bot (primeiro item onde asking = false)
      const botMessages = data.filter(msg => !msg.asking);
      const isFirstBotMessage = !asking && botMessages.length > 0 && botMessages[0].id === id;

      return (
        <Component
          key={`message-${id}_${uuidv4()}`}
          onIntent={onIntent}
          messageId={id}
          asking={asking}
          isFirstBotMessage={isFirstBotMessage}
          {...otherProps}
          {..._otherProps}
        >
          {content}
        </Component>
      );
    });
});

const MessageList = (props) => {
  const { data, runtime, onIntent, onFeedback, ...otherProps } = props;
  const boxRef = useRef(null);

  useEffect(() => {
    if (boxRef.current) {
      boxRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [data, runtime]);

  return (
    <StyledBox {...otherProps} onScroll={(e) => e.stopPropagation()}>
      {data && (
        <Messages
          data={data}
          component={Message}
          onIntent={onIntent}
          onFeedback={onFeedback}
        />
      )}
      {runtime && (
        <Message
          key={`message-${runtime.id}_${uuidv4()}`}
          thinking={runtime.status === "THINKING"}
          asking={runtime.asking || false}
          onIntent={onIntent}
          isFirstBotMessage={
            // Se não há mensagens do bot no data ainda, então runtime é a primeira mensagem do bot
            (data || []).filter(msg => !msg.asking).length === 0
          }
        >
          {runtime.content}
        </Message>
      )}
      <span ref={boxRef} />
    </StyledBox>
  );
};

export default MessageList;
